import { clsx } from "clsx";
import type { ReactNode, ComponentPropsWithoutRef, ReactElement } from "react";
import { Chip } from "@exopengithub/exokit";
import type { IconProps } from "@tabler/icons-react";
import { NavLink } from "react-router";

interface TabLinkProps
	extends Omit<ComponentPropsWithoutRef<typeof NavLink>, "children"> {
	count?: number;
	icon?: ReactElement<IconProps>;
	children?: ReactNode | undefined;
}

export const TabLink = ({
	className,
	children,
	count,
	icon,
	...props
}: TabLinkProps) => {
	return (
		<NavLink
			className={({ isActive }) => {
				return clsx(
					"group block cursor-pointer appearance-none border-b px-1 pb-4 pt-0.5",
					isActive
						? "border-b-purple-500"
						: "border-b-transparent hover:border-b-purple-500",
					className,
				);
			}}
			{...props}
		>
			{({ isActive }) => {
				return (
					<div
						className={clsx(
							"flex items-center whitespace-nowrap",
							isActive
								? "text-purple-500"
								: "text-gray-500 group-hover:text-purple-500",
						)}
					>
						{icon && <div className="mr-1">{icon}</div>}
						<span className="text-inherit font-medium text-sm">{children}</span>
						{count !== undefined ? (
							<Chip
								size="small"
								className="ml-2"
								variant={isActive ? "purple" : "gray"}
							>
								{count}
							</Chip>
						) : null}
					</div>
				);
			}}
		</NavLink>
	);
};
